export default "__VITE_ASSET__cyPYvePV__"